

































import { fetchSpeechBackends } from '@/core/api/speech-backends'
import Vue from 'vue'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
    backends: [],
    update: {
      backend: null,
    },
  }),
  watch: {
    show(newVal) {
      this.reset()
      fetchSpeechBackends().then(response => {
        this.backends = response
      })
      this.dialog = newVal
    },
  },
  methods: {
    reset() {
      this.update = {
        backend: null,
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit', this.update)
      this.close()
    },
  },
})
